
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speeds",
      function () {
        return require("private-next-pages/speeds/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speeds"])
      });
    }
  